import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useTabBarContext } from '../../../../Tabs';
import Btn, { BtnModifier } from '../../../../Btn';
import { Namespace } from '../../../../../../translation/namespace';

type MultiStepFormActionsProps = {
  renderSubmitAndLiveRegion?: ReactNode;
  tabId: string;
};

export default function MultiStepFormActions({ renderSubmitAndLiveRegion, tabId }: MultiStepFormActionsProps) {
  const {
    hasNextTab,
    setActiveTab,
    getNextTabIndex,
    getNextTab,
    hasPreviousTab,
    getPreviousTab,
    getPreviousTabIndex,
    isNextTabDisabled,
    focusById,
    setFooterButtonsClicked,
  } = useTabBarContext();
  const { t } = useTranslation(Namespace.MultiStepForm);

  return (
    <div className="multi-step-form__footer">
      <div className="multi-step-form__left">
        {hasPreviousTab(tabId) && (
          <Btn
            text={`${t('previousButton')} ${getPreviousTabIndex(tabId) + 1}`}
            type="button"
            onClick={() => {
              setActiveTab(getPreviousTab(tabId).id);
              focusById(`${getPreviousTab(tabId).id}-tabpanel`);
              setFooterButtonsClicked(true);
            }}
            modifier={BtnModifier.SINGLE_ACTION}
          />
        )}
      </div>
      <div className="multi-step-form__right">
        {hasNextTab(tabId) && (
          <Btn
            text={`${t('nextButton')} ${getNextTabIndex(tabId) + 1}`}
            type="button"
            ariaDisabled={isNextTabDisabled(tabId)}
            onClick={() => {
              setActiveTab(getNextTab(tabId).id);
              focusById(`${getNextTab(tabId).id}-tabpanel`);
              setFooterButtonsClicked(true);
            }}
            modifier={BtnModifier.SINGLE_ACTION}
          />
        )}
        {!hasNextTab(tabId) && renderSubmitAndLiveRegion && (
          <div className="multi-step-form__submit">{renderSubmitAndLiveRegion}</div>
        )}
      </div>
    </div>
  );
}
